import type { IEliteLoyaltyApiResponse } from '@cleartrip/ct-design-header'
import { HOME_API_ENDPOINTS, REQUEST_METHODS } from '@/constants/network'
import baseFetch from '@/network/baseFetch'
import { getApiDomain } from '@/utils/general/url'

const DEFAULT_TIMEOUT_MS = 5000

// /uhp/v1/loyalty/status — drives the header elite pill
export const getEliteMembershipStatus = async (
    isSignedIn: boolean
): Promise<IEliteLoyaltyApiResponse[] | null> => {
    try {
        let timeoutId: ReturnType<typeof setTimeout> | null = null
        const timeout = new Promise<null>(resolve => {
            timeoutId = setTimeout(() => resolve(null), DEFAULT_TIMEOUT_MS)
        })

        const request = baseFetch<IEliteLoyaltyApiResponse[]>({
            url: `${HOME_API_ENDPOINTS.LOYALTY_MEMBERSHIP_STATUS}?benefitsRequired=true`,
            method: REQUEST_METHODS.GET,
            domain: getApiDomain(),
            headers: {
                caller: 'AIR',
                channel: 'DESKTOP',
                userState: isSignedIn ? 'LOGGED_IN' : 'LOGGED_OUT',
                referer: typeof window !== 'undefined' ? window.location.href : ''
            }
        })

        const response = await Promise.race([request, timeout])
        if (timeoutId) {
            clearTimeout(timeoutId)
        }

        if (!Array.isArray(response)) {
            return null
        }
        return response
    } catch (e) {
        console.error('Elite membership status fetch failed:', e)
        return null
    }
}
